import { useAtom } from 'jotai';
import { Fragment } from 'react';

import ItemCategories from './components/ItemCategories';
import ItemGrid from './components/ItemGrid';
import { itemColumnsAtom } from '../../atoms/itemFilterAtoms';

function AllMenuFragment() {
  const [columns, setColumns] = useAtom(itemColumnsAtom);
  return (
        <Fragment >
            <ItemCategories columns={columns}
                            setColumns={setColumns} />
            <ItemGrid columns={columns}/>
        </Fragment>
  );
}

export default AllMenuFragment;
